<ng-template #content>
  <div class="d-flex align-items-center">
    <app-profile-image
      *ngIf="photo"
      [name]="row.name"
      [photoUrl]="row.logo"
      [width]="35"
    ></app-profile-image>
    <div>
      <h6 class="fs-10 text-black font-w600 mb-0 text-nowrap">
        {{ row.name | lettersOnly | reduceName : nameLength }}
      </h6>
      <span class="fs-8">
        {{ row.document | document : true }}
      </span>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="type !== undefined; else plainContent">
  <a href="javascript:void(0)" (click)="onClick()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<ng-template #plainContent>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>
